import { IAlertStatusProps } from '../../../../../global/components/toast-alert/ToastNotification'
import { fetchData } from '../../../../../global/utils/fetch'
import { insertEntity } from '../../../api'
import getEndpointPath from './get-endpoint-path'

async function saveNewRow(
  entityName: string,
  entityData: any,
  toastStatus: IAlertStatusProps,
  setToastStatus: Function,
  retrieveTableData: Function,
  setRow: Function,
) {
  const endpointPath = getEndpointPath(entityName)
  const saveApiCall = insertEntity(endpointPath, entityData)
  try {
    await fetchData(saveApiCall)

    setToastStatus({
      ...toastStatus,
      isOpen: true,
      message: [
        'Row saved successfully! You will be emailed when the change',
        'is visible in Tableau.',
      ].join(' '),
      severity: 'success',
    })

    setRow(null)
    retrieveTableData()
  } catch (error: any) {
    console.error('error', error)

    const cleanedErrorMessage = error.message.replace(
      'Error making API call: Error: ',
      '',
    )

    const errors = cleanedErrorMessage
      ? JSON.parse(cleanedErrorMessage).errors
      : cleanedErrorMessage

    const isValidationErrors = Array.isArray(errors)
    if (isValidationErrors) {
      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: [
          'The following errors occurred while trying to save the row:\n',
          errors.map((error) => error.message).join('\n'),
        ].join(' '),
        severity: 'error',
      })
    } else {
      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: [
          'An error occurred while saving the entity. Please try again. If the',
          `problem persists, contact support. ${error?.message}`,
        ].join(' '),
        severity: 'error',
      })
    }
  }
}

export default saveNewRow
